import { render, staticRenderFns } from "./SkolkovoDesktop.vue?vue&type=template&id=150e1b0c&"
import script from "./SkolkovoDesktop.vue?vue&type=script&lang=ts&"
export * from "./SkolkovoDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./SkolkovoDesktop.vue?vue&type=style&index=0&id=150e1b0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports